module.exports = __webpack_public_path__ + "static/media/che.4c2090e5.png";